import {ConsentSettings} from "./index";

export const ArgConsentSettings: ConsentSettings = {
    partnerMarketing: <>
        Acconsento al trattamento dei dati personali da parte di ARG Intermediazioni per la comunicazione a soggetti terzi per finalità promozionali e di marketing, come da informativa privacy: <a href={"https://static.ubi.datafolio.org/assets/partners/arg/privacy_information.pdf"}>ARG Privacy Policy</a>.
    </>
}